export default "__VITE_ASSET__CtRW6tq9__"